
export default function Benefit() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: '資産を守る',
      description:
        '精密機械、サーバー、制御盤。高額な資産を「粉塵被害」から完全に守ります。',
      color: 'bg-red-600',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-100',
    },
    {
      icon: 'ri-time-line',
      title: '時間を守る',
      description:
        '清掃は拭き取りのみ。ライン停止時間を極限まで短縮し、取引先への納期遵守を実現します。',
      color: 'bg-amber-600',
      bgColor: 'bg-amber-50',
      borderColor: 'border-amber-100',
    },
    {
      icon: 'ri-map-pin-range-line',
      title: '場所を選ばない',
      description:
        '90℃耐熱（SGS認証）。ボイラー室や夏場の倉庫など、従来のスプレーが置けなかった場所にも常備可能。',
      color: 'bg-teal-600',
      bgColor: 'bg-teal-50',
      borderColor: 'border-teal-100',
    },
  ];

  return (
    <section className="benefit-section py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="benefit-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ lineHeight: '1.5' }}>
            FIRE OUT 導入で得られる
            <br />
            3つの「守る力」
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className={`${benefit.bgColor} border ${benefit.borderColor} rounded-2xl p-6 md:p-10 text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2`}
            >
              <div
                className={`w-14 h-14 md:w-16 md:h-16 ${benefit.color} rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6`}
              >
                <i className={`${benefit.icon} text-2xl md:text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">{benefit.title}</h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .benefit-section {
            padding-top: 2rem !important;
            padding-bottom: 2rem !important;
          }
          .benefit-heading {
            font-size: 1.5rem !important;
            line-height: 1.6 !important;
          }
        }
      `}</style>
    </section>
  );
}
